// Input-time URL normalization for the `UrlInput` primitive. `stripUrlProtocol`
// renders the stored value without its scheme (nicer preview); the `normalize*`
// helpers re-add a scheme as the user types. Submit-time normalization (host
// lowercasing, empty -> null) is a separate concern owned by each form's schema.

// Same rule as the API's `WebsiteUrl`: an absolute http(s) URL on a domain name. `yup.url()` alone also lets
// "ftp://example.com", "//example.com" and "https://example.com." through, which the API then refuses.
export const WEBSITE_URL_REGEX = /^https?:\/\/[^\s/?#.:]+(\.[^\s/?#.:]+)+(:\d+)?([/?#]\S*)?$/i;

// Links pasted from a sentence often carry its punctuation ("monsite.fr."). Applied at validation, not while
// typing: stripping a trailing dot on each keystroke would make "monsite.fr" impossible to type.
export const removeTrailingPunctuation = <T extends string | null | undefined>(value: T): T | string =>
  typeof value === "string" ? value.trim().replace(/[.,;:!?]+$/, "") : value;

export const normalizeUrl = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) return "";
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed.replace(/^\/+/, "")}`;
};

export const normalizeSocialUrlInput = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) return "";
  const withoutProtocol = trimmed.replace(/^https?:\/\//i, "").replace(/^\/+/, "");
  return `https://${withoutProtocol}`;
};

export const stripUrlProtocol = (value: string): string => value.replace(/^https?:\/\//i, "");
